import React from "react";
import { PageLayout } from "../components/page-layout";
import { DocumentLibrary } from "../components/documents/DocumentLibrary";

/**
 * "My documents" page — the route shell for the saved-document library.
 *
 * Everything the page shows (heading, search, type filter chips, rows) belongs
 * to `DocumentLibrary`, so this file stays a shell: no second heading, no state.
 */
export const DocumentsPage: React.FC = () => {
  return (
    <PageLayout className="documents-layout">
      <DocumentLibrary />
    </PageLayout>
  );
};
